import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { REFERER } from '../../../referer-token';

export const originInterceptor: HttpInterceptorFn = (req, next) => {
  const headerReferer = req.headers.get('Referer');
  const referer = inject(REFERER, { optional: true });

  if (!headerReferer && referer) {
    return next(
      req.clone({
        headers: req.headers.set('X-Referer', referer),
      }),
    );
  }

  return next(req);
};
